import axios from '../../http';

import router from '../../routes';

const state = {
   equivalent: {
      equiCo2: {}
   },
   projects: []
};

const getters = {};

const actions = {
   async getCarbonEquivalent({ rootState, commit }) {
      const { uuid } = rootState.storage;

      try {
         const { data, status } = await axios({
            method: 'POST',
            url: `/request/clevel/customer/carbonoffset?uuid=${encodeURIComponent(uuid)}`
         });

         if (status == 200) {
            commit('updateState', {
               prop: 'equivalent',
               value: {
                  ...data,
                  carbonFootprint: data.carbonFootprint / 1000
               }
            });
         }

         return true;
      } catch (error) {
         commit('updateState', { prop: 'equivalent', value: {} });
         return false;
      }
   },
   async getProjects({ state, rootState, commit, dispatch }) {
      try {
         const { data, status } = await axios({
            method: 'GET',
            url: '/request/clevel/projects'
         });

         if (status == 200) {
            commit('updateState', { prop: 'projects', value: data.projects });
         }
      } catch (error) {
         commit('updateState', { prop: 'projects', value: [] });
      }
   },
   async selectProject({ state, rootState, commit, dispatch }, model) {
      const { uuid } = rootState.storage;
      model.uuid = uuid;

      try {
         const { data, status } = await axios({
            method: 'POST',
            url: `/request/clevel/customer/carbonoffset/payment`,
            data: model
         });

         if (status == 200) {
            window.location.replace(data.checkOutUrl);
         }
      } catch (error) {

      }
   },
   async processPayment({ commit }, { id, oid, c }) {
      try {
         const { data, status } = await axios({
            method: 'GET',
            url: '/request/clevel/customer/carbonoffset/payment/update',
            params: { id, oid, c }
         });

         commit('updateState', { prop: 'equivalent', value: data });
      } catch (e) {

      }
   }
};

const mutations = {
   updateState(state, { prop, value }) {
      state[prop] = value;
   }
};

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations
};
